import { combineReducers } from 'redux';
import createDomainFieldReducer, * as fromDomainField from './domain-field';

export interface DomainFields {
  free: fromDomainField.DomainField;
  product: fromDomainField.DomainField;
  transfer: fromDomainField.DomainField;
}

export function getValue(state: DomainFields, name: string): string {
  if (!state) {
    return null;
  }
  return fromDomainField.getValue(state[name as keyof DomainFields]);
}

export default combineReducers({
  [fromDomainField.FREE]: createDomainFieldReducer(fromDomainField.FREE),
  [fromDomainField.PRODUCT]: createDomainFieldReducer(fromDomainField.PRODUCT),
  [fromDomainField.TRANSFER]: createDomainFieldReducer(
    fromDomainField.TRANSFER
  ),
});
